export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70bd23c9f64e9c6cf8df09e61b40a04565ac2c6382&name=pushAdClickData!'